/**
 * @module printer
 */

import fleqv from '@/utils/fleqv.js'

const state = {
  active: false,
  queue: [],
  currentPrintID: 1,
  history: [],
}

const getters = {
}

const mutations = {
    enqueue(state, payload) {
        console.log("enqueue")
        state.queue.push(payload)
    },

    dequeue(state, payload) {
        console.log("dequeue")
        state.queue = state.queue.filter(e => e.id != payload.id)
        state.history.push(payload)
    },
}

const actions = {
    async printTanpinNebiki({ commit }, { printerURL, layoutFileBase64, formatId, printParams }) {
        const printKey = {
            id: "" + Date.now(),
        }

        try {
            commit("enqueue", printKey)

            const res = await fleqv.print(printerURL, layoutFileBase64, formatId, printParams)
            const text = await res.text()
            console.log(text)

            if (res.status != 200) {
                throw "ラベルの発行に失敗しました"
            }

            const parser = new DOMParser();
            const xml = parser.parseFromString(text, "text/xml");

            commit("dequeue", printKey)

            if (xml.querySelector("result").textContent != "OK") {
                throw "ラベルの発行に失敗しました。\n" + text
            }

            return true
        } catch (error) {
            console.log(error)
            commit("dequeue", printKey)
            throw "ラベルの発行に失敗しました。\n" + error
        }
    },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
